import ContactUs from "./components/ContactUs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WhyChooseUs from "./components/WhyChooseUs";

export function AboutUsPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace(/^#/, "");
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  return (
    <main>
      <Main />
      <Content />
      <Solutions />
      <WhyChooseUs />
      <ContactUs />
    </main>
  );
}

function Main() {
  const { t } = useTranslation();
  
  return (
    <div
      className="py-16 relative"
      style={{
        backgroundImage: "url(/assets/img/about-us/main.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container px-8 md:px-[100px] py-[130px] relative z-10">
        <h1 className="text-left md:leading-[64px] text-[40px] md:text-5xl font-light text-white mb-8">
          {t('AboutUsPage.main.title')}
        </h1>
      </div>
    </div>
  );
}

function Content() {
  const { t } = useTranslation();
  
  const descriptions = [
    t('AboutUsPage.content.steelList.hotRolled'),
    t('AboutUsPage.content.steelList.coldRolled'),
    t('AboutUsPage.content.steelList.coldRolledCrude'),
    t('AboutUsPage.content.steelList.galvanized'),
    t('AboutUsPage.content.steelList.aluminized'),
    t('AboutUsPage.content.steelList.prePainted'),
    t('AboutUsPage.content.steelList.enamel'),
    t('AboutUsPage.content.steelList.tinPlate'),
  ];
  
  return (
    <div className="bg-[#F2F6FB] md:pb-32 pb-16 w-full relative">
      <img
        className="absolute top-0 left-0 z-0"
        src="/assets/img/diagonal-left.png"
        alt="Diagonal"
        loading="lazy"
        decoding="async"
      ></img>
      <div className="mx-auto px-8 md:px-28 pt-16 relative z-10">
        <div
          className={`space-y-28 md:pt-28 transition-all duration-1000 delay-600`}
        >
          <div className="xl:flex space-y-12 md:space-y-0 justify-between">
            <div className="w-full flex flex-col space-y-8 text-left">
              <h2 className="md:text-6xl text-4xl font-light text-left md:leading-[80px] leading-[50px]">
                {t('AboutUsPage.content.title')}{" "}
                <span className="font-medium">{t('AboutUsPage.content.titleBold')}</span>
              </h2>

              <div className="md:text-base text-sm font-medium mb-14 text-left">
                <p className={`text-[#013B8F]`}>
                  {t('AboutUsPage.content.description')}
                </p>
              </div>
              <p className="md:text-base text-sm font-normal space-y-6">
                {t('AboutUsPage.content.steelTypes')}
              </p>
              <div className="my-8 space-y-6">
                {descriptions.map((description) => (
                  <div className="flex items-center space-x-2" key={description}>
                    <img
                      src={`/assets/svg/check.svg`}
                      alt={"check"}
                      loading="lazy"
                      decoding="async"
                    />
                    <p className="md:text-base text-sm font-normal">
                      {description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full text-left relative">
              <div className="md:flex justify-between items-center space-y-4 md:space-y-0">
                <img
                  src="/assets/img/about-us/103.png"
                  alt="About Us 1"
                  className="rounded-lg w-[398px] rounded-[40px"
                  loading="eager"
                  decoding="async"
                  fetchPriority="high"
                />
                <div className="flex w-full items-center gap-x-1 text-right justify-start">
                  <p className="w-full text-center text-[#03275A] font-bold text-5xl">
                    + 40
                  </p>
                  <p className="w-full text-xl font-normal text-left text-[#222222]">
                    {t('AboutUsPage.content.yearsExperience')}
                  </p>
                </div>
              </div>

              <img
                src="/assets/img/about-us/104.png"
                alt="About Us 2"
                className="border-[10px] border-white hidden xl:block absolute top-[200px] right-0 rounded-lg w-[559px]"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Solutions() {
  const { t } = useTranslation();
  
  return (
    <div id="ISO-9001"
      className="py-16 relative"
      style={{
        backgroundImage:
          "linear-gradient(-90deg, rgba(1,78,159,0.7), rgba(0,85,164,0.7), rgba(3,41,96,0.7)), url(/assets/img/about-us/105.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="mx-auto px-8 md:px-28 mt-16 py-6 space-y-16 relative z-10">
        <p className="text-left md:leading-[50px] leading-[30px] md:text-4xl text-2xl font-light text-white">
          {t('AboutUsPage.solutions.title')} <span className="font-bold">{t('AboutUsPage.solutions.titleBold')}</span>
        </p>
        <p>
          <p className="md:text-right text-left md:leading-[50px] leading-[30px] md:text-4xl text-2xl font-semibold text-white">
            {t('AboutUsPage.solutions.subtitle')}
          </p>
        </p>
      </div>
    </div>
  );
}
